<!-- Progress bar -->
<gnx-progress-bar></gnx-progress-bar>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layout selection based on configuration or user preference  -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<gnx-default-layout *ngIf="layout === 'default-layout'"></gnx-default-layout>
